<template>
  <div class="btns" :style="{justifyContent: align?align:'center'}">
    <CancelBtn @click="$emit('cancel')"/>
    <SaveBtn @click="$emit('save')" :text="save"/>
  </div>
</template>

<script>
import SaveBtn from './save.vue'
import CancelBtn from './cancel.vue'
export default {
  props: ['align', 'save'],
  components: {
    SaveBtn,
    CancelBtn
  }

}
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  align-items: center;
  gap: 25px;
}
</style>
